import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {starfishMediaType} from 'utils/types';
import useStarfishAPI from "../hooks/useStarfishAPI";
import {isEmpty} from 'lodash';
import LoadingScreen from "./LoadingScreen";
import ErrorScreen from "./ErrorScreen";
import useDashboardError from "./useDashboardError";
import css from "./ServiceList.css"
import Service from "./Service";
import {isServiceInSuccessNetwork} from "../serviceCatalog/home/services/serviceUtils";

const servicesInSuccessNetwork = (allServices) =>
  allServices.filter(service => isServiceInSuccessNetwork(service))

const isLastService = (serviceIndex, totalServices) => serviceIndex === totalServices - 1

const displayVirtualCheckInLink = (props, service) =>
  props.responsiveKioskEnabled && props.virtualCheckInEnabled && service.virtualCheckInEnabled

const ServiceList = (props) => {
  const [response, callServicesList] = useStarfishAPI({isNewAPI: true});
  const [studentServices, setStudentServices] = useState([])

  useEffect(() => {
    callServicesList(
      `../api/starfish/success-network/services`,
      {
        method: "GET",
        headers: {
          'Accept': starfishMediaType('successnetwork')
        }
      })
  }, []);

  useEffect(() => {
    if (response.success) {
      props.setCount(servicesInSuccessNetwork(response.data.services).length);
      setStudentServices(servicesInSuccessNetwork(response.data.services))
    }
  }, [response]);

  useDashboardError(response, props.setError)

  const containerClasses = [css.content];
  if (response.success && !isEmpty(studentServices)) containerClasses.push(css.border);

  const getContent = () => {
    if (response.pending) return <LoadingScreen/>
    if (response.error) return <ErrorScreen/>
    if (response.success && isEmpty(studentServices)) return "When we connect you with services, you will see them here.";
    if (response.success && !isEmpty(studentServices))
      return studentServices.map(
        (service, serviceIndex) =>
          <Service
            key={service.uuid}
            serviceId={service.id}
            uuid={service.uuid}
            serviceName={service.serviceDisplayName || service.name}
            location={service.location}
            kioskMaxWaitTime={service.kioskMaxWaitTime}
            kioskQueueSize={service.kioskQueueSize}
            phoneNumber={service.phoneNumber}
            onlineSchedulingAvailable={service.onlineSchedulingAvailable}
            hoursOfOperation={service.hoursOfOperation}
            kioskId={service.kioskId}
            kioskType={service.kioskType}
            url={service.url}
            email={service.email}
            upwards={isLastService(serviceIndex, studentServices.length)}
            virtualCheckInEnabled={displayVirtualCheckInLink(props, service)}
            checkedIntoService={service.checkedIntoService}
            virtualCheckInOpen={service.virtualCheckInOpen}
          />
      )
  };

  return (
    <div className={containerClasses.join(" ")} data-testid='services'>
      {getContent()}
    </div>
  );
};

ServiceList.propTypes = {
  setCount: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  responsiveKioskEnabled: PropTypes.bool,
  virtualCheckInEnabled: PropTypes.bool
};

export default ServiceList;
